// src/services/employeeService.js - UPDATED with filter self boolean support
import api from './api.js';

const employeeService = {
  // Get all employees for a company
  getCompanyEmployees: async (companyId) => {
    try {
      const response = await api.get(`/employees/company/${companyId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch company employees');
    }
  },
  
  // Get employee types
  getEmployeeTypes: async () => {
    try {
      const response = await api.get('/employees/types');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch employee types');
    }
  },
  
  // Add an employee to a company
  addEmployeeToCompany: async (companyId, employeeData) => {
    try {
      const response = await api.post(`/employees/company/${companyId}`, employeeData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to add employee to company');
    }
  },
  
  // Update an employee
  updateEmployee: async (companyEmployeeId, updateData) => {
    try {
      const response = await api.put(`/employees/${companyEmployeeId}`, updateData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update employee');
    }
  },

  // Get user companies (companies where user is an employee)
  getUserCompanies: async (memberId) => {
    try {
      const response = await api.get(`/companies/member/${memberId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch user companies');
    }
  },
  
  // Remove an employee from a company (DELETE)
  removeEmployeeFromCompany: async (companyEmployeeId) => {
    try {
      const response = await api.delete(`/employees/${companyEmployeeId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to remove employee from company');
    }
  },

  // Update filter self boolean for an employee
  updateFilterSelfBoolean: async (memberId, filterSelfBoolean) => {
    try {
      const response = await api.put(`/employees/filter-self/${memberId}`, {
        filterOrdersBySelfBoolean: filterSelfBoolean
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update filter setting');
    }
  },

  // Get filter self boolean for an employee
  getFilterSelfBoolean: async (memberId) => {
    try {
      const response = await api.get(`/employees/filter-self/${memberId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to get filter setting');
    }
  },

  // Join company via secret code
  joinCompanyViaSecretCode: async (data) => {
    try {
      const response = await api.post(
        `/employees/join-via-code`,
        data,
        { withCredentials: true }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to join company');
    }
  }
};

export default employeeService;